import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { GET_PARTICIPANTS_FOR_PROJECT } from '@api/queries/projects';
import {
    type OrganizationUserParticipantFragment,
    type ProjectUserParticipantFragment,
} from '@gql/graphql';
import { type Resource } from '@models/Resource';
import { flatMapEdges } from '@utils/flatMapEdges';
import { isDefined } from '@utils/isDefined';

export type ProjectParticipant =
    | OrganizationUserParticipantFragment
    | ProjectUserParticipantFragment;

export function useProjectParticipants(): Resource<ProjectParticipant> {
    const { pid } = useParams();
    const { data, loading, refetch } = useQuery(GET_PARTICIPANTS_FOR_PROJECT, {
        skip: !pid,
        variables: {
            pid: pid!,
        },
        fetchPolicy: 'cache-and-network',
    });

    const participants = useMemo(
        () =>
            flatMapEdges(data?.projects)
                .flatMap((n) => n.participants)
                .filter(isDefined),
        [data],
    );

    return {
        loading,
        options: participants,
        refetch: async () => {
            await refetch();
        },
    };
}
